import { createStore } from 'effector';

import { NotificationsModes } from 'types/zod/notifications-modes';
import { ParticipantInDocument } from 'types/zod/participant-in-document';

export const $notifiable = createStore<{
    participants: ParticipantInDocument[];
    mode?: NotificationsModes;
} | null>(null);
